module.exports = __webpack_public_path__ + "static/media/M.3b082c8c.jpg";